import { config as AWSConfig, Iot, CognitoIdentity, CognitoIdentityCredentials } from 'aws-sdk';
import aws_exports from './aws-exports';
import { AWSIoTProvider } from '@aws-amplify/pubsub';
import Amplify from '@aws-amplify/core';
import Storage from '@aws-amplify/storage';
import { getMountedApps, unloadApplication } from 'single-spa';
import { Roles } from './authTypes';
import { getCurrentUser, getUserCredentials, setUserCredentials } from './user';
import { navigateToUrl } from 'single-spa';


Amplify.configure(aws_exports);
Storage.configure({
    customPrefix: {
        public: '',
    },
})

export const getStorage = () => Storage;

export const attachPolicy = (callback?: () => void) => {
    const IoT = new Iot();
    IoT.attachPolicy({
        policyName: process.env.AWS_COGNITO_POLICY_NAME, // TODO: Its just test policy. Need to be change
        target: (<CognitoIdentityCredentials>AWSConfig.credentials).identityId
    },
        callback
    );
};

export const switchCognitoRole = async (factory: string) => {
    const { identityId } = getUserCredentials()
    const cognitoIdentity = new CognitoIdentity({
        region: aws_exports.Auth.region,
    })
    const params = {
        IdentityId: identityId,
        CustomRoleArn: getCurrentUser().cognitoRoles.get(factory),
        Logins: {
            [process.env.AWS_COGNITO_CREDENTIAL_LOGINS]: getCurrentUser().credentials.idToken
        }
    };
    return new Promise((resolve, reject) => cognitoIdentity
        .getCredentialsForIdentity(params)
        .promise()
        .then(data => {
            setUserCredentials({
                accessKeyId: data.Credentials.AccessKeyId,
                sessionToken: data.Credentials.SessionToken,
                secretAccessKey: data.Credentials.SecretKey,
            })
            resolve(true)
        })
        .catch(err => reject(err))
    );
};

export const setCogitoCredentials = (user: any) => {
    return new Promise(resolve => {
        AWSConfig.region = aws_exports.Auth.region;
        AWSConfig.credentials = new CognitoIdentityCredentials({
            IdentityPoolId: aws_exports.Auth.identityPoolId,
            Logins: {
                [process.env.AWS_COGNITO_CREDENTIAL_LOGINS]: user.signInUserSession.getIdToken().getJwtToken()
            }
        });
        AWSConfig.getCredentials(() => attachPolicy(() => setMQTT(resolve)));
    })
};

export const setMQTT = (done: (value: boolean) => void) => {
    Amplify.addPluggable(new AWSIoTProvider({
        aws_pubsub_region: process.env.AWS_PUBSUB_REGION,
        aws_pubsub_endpoint: process.env.AWS_PUBSUB_ENDPOINT
    }));
    done(true)
};

export const getFactoryList = (user: any) => {
    const firstValue = 0;
    const gropups: string[] = user.signInUserSession.getIdToken().decodePayload()?.['cognito:groups'];
    const preferredRoles: string = user.signInUserSession.getIdToken().decodePayload()?.['cognito:preferred_role'];
    const preferredFactory = preferredRoles.match(/(?<=pr4-app-)(.*)(?=-)/)[firstValue].split('-')[firstValue]

    const factories = gropups
        .filter(group => group.search(/AzureAD/i) === -1)
        .map(group => group.split('_')[firstValue])
        .filter((group: string) => group !== 'MAINTENANCE');

    const uniqFactories = [...new Set(factories)]
    return { factories: uniqFactories, currentFactory: preferredFactory }
};

export const getUsername = (user: any) => {
    const fullUsername = user.getUsername() as string;
    const containPrefix = fullUsername.search(/AzureAD/i) !== -1;
    if (containPrefix) {
        return fullUsername.substring((fullUsername.search(/_/i) + 1), fullUsername.search(/@/i));
    }
    return fullUsername.substring(0, fullUsername.search(/@/i));
};

const setPriorityRoleForFactory = (gropups: string[][]) => {
    const priority = Object.keys(Roles);

    const setRolePrority = (a: string, b: string) => {
        return priority.indexOf(a) - priority.indexOf(b)
    };

    return Object.entries(gropups.reduce((acc, [key, value]) => {
        const listOfRoles = acc[key] ? [...acc[key], value] : [value]
        return Object.assign({}, acc, { [key]: listOfRoles });
    }, {})).map(([factory, roles]: [string, string[]]) => {
        const prioritizedRole = roles.sort(setRolePrority)[0]
        return [factory, Roles[prioritizedRole]] as [string, Roles]
    });
};

export const setMapOfRoles = (user: any) => {
    const roles = new Map<string, Roles>()

    const gropups: string[][] = user.signInUserSession.getIdToken().decodePayload()?.['cognito:groups']
        .filter(group => group.search(/AzureAD/i) === -1)
        .map(group => group.split('_'))
        .filter((group: string[]) => group.length === 2);

    const prioritizedRole = setPriorityRoleForFactory(gropups);

    prioritizedRole.forEach(([factory, role]) => {
        roles.set(factory, role)
    });
    return roles;
};

const setCognitoRoles = (user: any, roles: Map<string, Roles>): Map<string, string> => {
    const cognitoRoles = new Map<string, string>();
    const listOfCognitoRoles = user.signInUserSession.getIdToken().decodePayload()?.['cognito:roles'];
    [...roles.entries()].forEach(([factory, role]) => {
        const stringRegex = `^(?=.*\\b${factory}\\b)(?=.*\\b${role}\\b).*$`;
        const regex = new RegExp(stringRegex, "gi")
        cognitoRoles.set(factory, listOfCognitoRoles.find((el: string) => el.match(regex)))
    })
    return cognitoRoles;
};

export const getUserData = (user: any): [string[], string, string, Map<string, Roles>, Map<string, string>] => {
    const { factories, currentFactory } = getFactoryList(user);
    const username = getUsername(user);
    const roles = setMapOfRoles(user);
    const cognitoRoles = setCognitoRoles(user, roles);
    return [factories, currentFactory, username, roles, cognitoRoles];
};

export const reloadCurrentViews = async () => {
    const mounted = getMountedApps().filter((el: string) => el !== '@pmi/navigation');
    mounted.forEach(async (el: string) => {
        await unloadApplication(el)
    })
    navigateToUrl('/dashboard');
};

export const refreshCurrentSession = async () => {
  try {
    
    const { identityId } = getUserCredentials();
    const { factory } = getCurrentUser();
    const cognitoIdentity = new CognitoIdentity({
      region: aws_exports.Auth.region,
    });

    const params = {
      IdentityId: identityId,
      CustomRoleArn: getCurrentUser().cognitoRoles.get(factory),
      Logins: {
        [process.env.AWS_COGNITO_CREDENTIAL_LOGINS]: getCurrentUser().credentials.idToken,
      },
    };

    const data = await cognitoIdentity.getCredentialsForIdentity(params).promise();
    setUserCredentials({
      accessKeyId: data.Credentials.AccessKeyId,
      sessionToken: data.Credentials.SessionToken,
      secretAccessKey: data.Credentials.SecretKey,
    });

    console.log("Session successfully refreshed.");
  } catch (error) {
    console.error("Error refreshing session credentials:", error);
  }
};
